import { create } from 'zustand'
import type { IUiState } from './uiState'

export const useUiState = create<IUiState>((set, get) => ({
  isDark: true,
  setIsDark: (dark) => set({ isDark: dark }),
  onToggleIsDark: () => set({ isDark: !get().isDark }),
  cursor: undefined,
  setCursor: (cursor) => set({ cursor }),
  mousePosition: { clientX: 0, clientY: 0 },
  setMousePosition: (mouse) => set({ mousePosition: mouse }),
  modal: undefined,
  onToggleModal: (modal) =>
    set(({ modal: prevModal }) => ({
      modal: prevModal === modal ? undefined : modal,
      navAction: undefined,
      lockScroll: prevModal !== modal,
    })),
  onClearModal: () => set({ modal: undefined }),
}))
